<template>
    <div>
        <GateNumberDialog
            :is-open="gateNumberDialog"
            :courier-data="courier"
            :gates-data="gates"
            @get-couriers="getCouriers"
            @on-close="closeGateNumberDialog"
        />
        <v-dialog
            :value="isOpen"
            max-width="700px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Lista przewoźników
                    </h1>
                </v-card-title>
                <v-data-table
                    :headers="headers"
                    :items="couriers"
                    :mobile-breakpoint="0"
                    hide-default-footer
                    disable-pagination
                    name="couriersData"
                >
                    <template #item.name="{item}">
                        {{ item.name }}
                    </template>
                    <template #item.gateNumber="{item}">
                        {{ item.gateNumber }}
                    </template>
                    <template #item.actions="{item}">
                        <div class="d-inline-flex">
                            <v-tooltip :open-delay="tooltipDelay" top>
                                <template #activator="{on}">
                                    <v-btn
                                        icon
                                        data-sentry-label="Edytuj"
                                        v-on="on"
                                        @click="showEditGateNumberDialog(item)"
                                    >
                                        <v-icon color="teal">
                                            mdi-pencil
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Edytuj</span>
                            </v-tooltip>
                        </div>
                    </template>
                </v-data-table>
                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Zamknij"
                        @click="onClose"
                    >
                        Zamknij
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import tooltipDelay from '@/mixins/tooltip'
import GateNumberDialog from './GateNumberDialog'

export default {
    name: 'CouriersListDialog',
    components: {
        GateNumberDialog
    },
    mixins: [
        tooltipDelay
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        couriersData: {
            type: Array,
            default: null
        },
    },
    data() {
        return {
            courier: null,
            couriers: [],
            gates: [],
            gateNumberDialog: false,
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false,
                },
                {
                    text: 'Numer bramki',
                    value: 'gateNumber',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    watch: {
        isOpen() {
            if (this.couriersData === null) return
            this.couriers = JSON.parse(JSON.stringify(this.couriersData))
        }
    },
    methods: {
        getCouriers() {
            this.$store.dispatch('shipments/sendings/getCouriers')
                .then(response => {
                    this.couriers = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showEditGateNumberDialog(courier) {
            this.courier = courier
            this.gateNumberDialog = true
        },
        closeGateNumberDialog() {
            this.gateNumberDialog = false
            this.courier = null
            this.gates = []
        },
        onClose() {
            this.$emit('on-close')
        }
    }
}
</script>
